import { Component, OnInit } from '@angular/core';
import { Shell, NamedDialog, DialogComponent, EmailValidator, PageService } from '@tytapp/common';
import { PasswordStrength, PasswordStrengthResult } from '@tytapp/validation';
import { UserService } from '../user.service';
import { ApiUser, UsersApi } from '@tytapp/api';

@NamedDialog('forgot')
@Component({
    selector: 'app-forgot',
    templateUrl: './forgot.component.html',
    styleUrls: ['./forgot.component.scss']
})
export class ForgotComponent extends DialogComponent implements OnInit {

    constructor(
        private userService: UserService,
        private passwordStrength: PasswordStrength,
        private pageService: PageService,
        private userApi: UsersApi
    ) {
        super(pageService);
    }

    public email: string;
    public token: string = null;
    public newPassword: string = null;
    public confirmPassword: string = null;
    public strength: PasswordStrengthResult = null;

    init(params) {
        this.token = params ? params.token : null;
    }

    passwordChanged: boolean = false;
    requestSubmitted: boolean = false;
    user: ApiUser = null;

    async submitChange(token, password) {
        try {
            let userAuthToken = await this.userApi.resetPassword({ token, password }).toPromise();
            this.userService.completeLogin(userAuthToken, userAuthToken.token, false);
            this.passwordChanged = true;
            this.user = userAuthToken;
        } catch (e) {
            this.showError(e.message || e.error);
        }
    }

    async submitRequest(email) {
        try {
            await this.userApi.requestPasswordReset({ email }).toPromise();
            this.requestSubmitted = true;
        } catch (e) {
            this.showError(e.message || e.error);
        }
    }

    public matches: boolean = null;

    checkMatch() {
        if (!this.confirmPassword) {
            this.matches = null;
            this.removeFieldError('confirm-password');
            return;
        }

        if (this.newPassword != this.confirmPassword) {
            this.addFieldError('confirm-password', 'Confirmation does not match');
            this.matches = false;
        } else {
            this.removeFieldError('confirm-password');
            this.matches = true;
        }
    }

    checkStrength(final: boolean = false) {
        if (!this.newPassword) {
            this.strength = null;
            return;
        }

        this.strength = this.passwordStrength.check(this.newPassword);

        if (this.strength.strengthCode == 'VERY_WEAK' || this.strength.strengthCode == 'WEAK') {
            this.addFieldError('new-password', final ? 'Not strong enough' : null);
        } else {
            this.removeFieldError('new-password');
        }
    }

    submit() {
        if (this.token) {

            let missingStuff = false;

            if (!this.newPassword) {
                missingStuff = true;
                this.addFieldError('new-password', 'Provide a new password');
            }

            if (!this.confirmPassword) {
                missingStuff = true;
                this.addFieldError('confirm-password', 'Repeat your chosen password here');
            }

            if (missingStuff) {
                this.shell.shakeDialog();
                return;
            }

            if (this.newPassword != this.confirmPassword) {
                this.showError('The given passwords do not match');
                return;
            }

            this.submitChange(this.token, this.newPassword);
        } else {
            let emailValidator = new EmailValidator(this.email);
            let result = emailValidator.validate();

            if (result !== true) {
                this.showError("" + result, [{ field: 'email' }]);
                return;
            }

            this.submitRequest(this.email);
        }
    }

    backToLogin() {
        this.shell.animateToDialog('fly', Shell.getDialogByName('login')); // to avoid circular ref
    }

}
